import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from '@fluentui/react-components';
import {
  Delete20Regular,
  Edit20Regular,
  MoreHorizontal20Regular,
} from '@fluentui/react-icons';

/**
 * Composant label pour le nœud Disconnect
 * Accepte soit routing/routingKey (routing normal) soit optionData (nœud terminal)
 */
const DisconnectNodeLabel = ({ routingKey, routing, optionData, handleEditNode, handleDeleteNode }) => {
  const { t } = useTranslation();
  // Si c'est un nœud terminal (optionData existe)
  if (optionData) {
    const nodeId = 'disconnect-node';
    
    return (
      <div className="node-disconnect">
        <Menu>
          <MenuTrigger disableButtonEnhancement>
            <button
              className="node-menu-btn"
              onClick={(e) => e.stopPropagation()}
              title="Options"
            >
              <MoreHorizontal20Regular />
            </button>
          </MenuTrigger>
          <MenuPopover>
            <MenuList>
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditNode(nodeId);
                }}
              >
                {t('EDIT')}
              </MenuItem>
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteNode(nodeId);
                }}
              >
                {t('DELETE')}
              </MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
        <div className="node-title">📴 {t('DISCONNECT')}</div>
        <div className="node-separator"></div>
        <div className="node-info">
          <div className="node-info-item">{t('END_CALL')}</div>
        </div>
      </div>
    );
  }
  
  // Sinon, c'est un routing normal
  const routingId = `routing-${routingKey}`;
  
  // Gérer l'affichage du nom
  let displayName;
  if (routingKey === '0') {
    displayName = t('START');
  } else if (routing?.displayName && routing.displayName.trim()) {
    displayName = routing.displayName;
  } else {
    // Si pas de displayName, afficher juste "Disconnect" au lieu du routingKey généré
    displayName = t('DISCONNECT');
  }
  
  const isDefaultRouting = routingKey === '0';

  return (
    <div className="node-routing">
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <button
            className="node-menu-btn"
            onClick={(e) => e.stopPropagation()}
            title="Options"
          >
            <MoreHorizontal20Regular />
          </button>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem
              icon={<Edit20Regular />}
              onClick={(e) => {
                e.stopPropagation();
                handleEditNode(routingId);
              }}
            >
              {t('EDIT')}
            </MenuItem>
            {!isDefaultRouting && (
              <MenuItem
                icon={<Delete20Regular />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteNode(routingId);
                }}
              >
                {t('DELETE')}
              </MenuItem>
            )}
          </MenuList>
        </MenuPopover>
      </Menu>
      <div className="node-title">{displayName}</div>
      <div className="node-separator"></div>
      <div className="node-info">
        <div className="node-info-item">{t('DISCONNECT')}</div>
      </div>
    </div>
  );
};

export default DisconnectNodeLabel;
